<article class="container">
    <div class="row">
        <div class="col-12 col-md-5">
            <div class="text-content">
                <div class="headline">
                    <app-spot-headline *ngIf="data.headlineText as headlineText" [index]="data.spotIndex">
                        {{ headlineText }}
                    </app-spot-headline>
                </div>
                <div
                    *ngIf="data.richText"
                    class="kk-rte"
                    appInterceptLinks
                    [innerHTML]="data.richText | safe: 'html'"
                ></div>
                <div class="link-wrapper">
                    <app-arrow-link *ngIf="data.link as link" [link]="link">
                        {{ link.name }}
                    </app-arrow-link>
                </div>
            </div>
        </div>
        <div class="col-1">
            <div class="image-wrapper left-image">
                <div appParallaxElement [travel]="80" [dullness]="10">
                    <app-image
                        *ngIf="data.leftImage"
                        [image]="data.leftImage"
                        [width]="420"
                        [height]="420"
                        [index]="data.spotIndex"
                        crop="crop"
                    ></app-image>
                </div>
            </div>
        </div>
        <div class="col-10 col-md-5">
            <div
                class="image-wrapper center-image"
                [ngClass]="{ 'left-image-exists': data.leftImage !== null }"
                appParallaxElement
                [travel]="40"
                [dullness]="20"
            >
                <app-image [image]="data.centerImage" [width]="535" [height]="720" [index]="data.spotIndex"></app-image>
            </div>
        </div>
        <div class="col-md-1">
            <div class="right-content">
                <div class="image-wrapper right-image" appParallaxElement [travel]="170" [dullness]="5">
                    <app-image
                        [image]="data.rightImage"
                        [width]="420"
                        [height]="420"
                        [index]="data.spotIndex"
                    ></app-image>
                </div>
            </div>
        </div>
    </div>
</article>
